<template>
  <div class="tagStyle">
    <el-scrollbar>
      <div>
        <router-link
          v-for="tag in visitedViews"
          ref="tag"
          :key="tag.path"
          :to="tag.path"
          class="tags-view-item"
        >
          {{ $t("NavMenu." + tag.meta.title) }}
          <span
            v-if="!isAffix(tag)"
            class="el-icon-close"
            @click.stop.prevent="closeSelectedTag(tag)"
          />
        </router-link>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  data() {
    var visitedViews = [];
    if (sessionStorage.getItem("userType") == 0) {
      visitedViews = [
        {
          path: "/VehicleManagement/VehicleFiles",
          name: "VehicleFiles",
          meta: {
            title: "VehicleFiles",
            affix: true,
            keepAlive: true,
          },
        },
      ];
    } else {
      visitedViews = [
        {
          path: "/GovernmentRegulation/JurisdictionalCompanies",
          name: "JurisdictionalCompanies",
          navShow: false,
          meta: {
            title: "JurisdictionalCompanies",
            affix: true,
            keepAlive: true,
          },
        },
      ];
    }
    return {
      visitedViews: visitedViews,
    };
  },
  created() {
    this.getTagView();
  },
  watch: {
    $route() {
      this.getTagView();
    },
    visitedViews: {
      deep: true,
      immediate: true,
      handler: function (val) {
        const arr = val && val.filter((item) => {
              return item.name;
        }).map((item) => {
              return item.name;
        });
        this.$store.dispatch("cache/GET_KEEP_ALIVE", arr);
      },
    },
  },
  methods: {
    getTagView() {
      if (
        this.$route.path !==
        "/BackgroundSettings/DictionaryManaged/DictionaryItem" && this.$route.path !==
        "/GovernmentRegulation/EnforcementNotes/NoteDetail"
      ) {
        console.log(this.$route);
        const CurrentRoute = this.$route;
        const Obj = this.visitedViews.find(
          (item) => item.path === CurrentRoute.path
        );
        if (!Obj) {
          this.visitedViews.push(CurrentRoute);
        }
      }
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix;
    },

    closeSelectedTag(view) {
      if (view) {
        let CurrentIndex = this.visitedViews.findIndex(
          (item) => item.path === view.path
        );
        let obj = this.visitedViews[CurrentIndex - 1];
        this.visitedViews.splice(CurrentIndex, 1);
        this.$router.push(obj.path);
      } else {
        if (view.name === "VehicleFiles") {
          this.$router.replace({ path: view.fullPath });
        } else {
          this.$router.push("/");
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tagStyle {
  height: 26px;
  line-height: 26px;
  /deep/.el-scrollbar {
    white-space: nowrap;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 26px;
    .el-scrollbar__wrap {
      height: 45px;
      margin-bottom: -17px !important;
      a {
        color: #fff;
        text-decoration: none;
        border: 1px solid #7f8791;
        font-size: 14px;
        margin-right: 5px;
        padding: 2px 6px;
      }
      .router-link-active {
        border: 1px solid #7f8791;
        color: #409eff;
      }
    }
  }
}
</style>
